<template>
  <div>
    <!-- <div id="element" @scroll="handleScroll">
      <iframe class="mt-2" @scroll="handleScroll"
        src="https://servintp.latinoseguros.com.mx:8091/sites/uploads/condiciones/CGCNSFS0013VALORLATINO2022.htm" 
        width="100" height="100"> 
      </iframe>

</div> -->
    <div class="text-center">
      <div class="row">
        <div class="col-1"></div>
        <div class="col-10">
          <div class="elemento">
            <iframe class="mt-2" @scroll="handleScroll" id="myIframe"
            src="https://servintp.latinoseguros.com.mx:8091/sites/uploads/condiciones/CGCNSFS0013VALORLATINO2022.htm" 
            width="100">
            </iframe>
          </div>
          <!-- <div class="elemento" id="element" @scroll="handleScroll">
            <iframe class="mt-2" @scroll="handleScroll" id="myIframe"
            src="https://servintp.latinoseguros.com.mx:8091/sites/uploads/condiciones/CGCNSFS0013VALORLATINO2022.htm" 
            width="100">
            </iframe>
          </div> -->
        </div>
        <div class="col-1"></div>
      </div>
      <div class=" mt-3 mr-2">
          <p >Declaro mi total conformidad con las condiciones generales para la contratación del seguro solicitado, así como el aviso de privacidad</p>
          <button class="btn btn-rounded float-right mb-3" 
          data-bs-target="#avisoPrivacidadModal" @click="sendTerminos"
          data-bs-toggle="modal">
          Acepto
        </button>
          <!-- <button :disabled="ifScroll" class="btn btn-rounded float-right mb-3" 
          data-bs-target="#avisoPrivacidadModal" @click="sendTerminos"
          data-bs-toggle="modal">
          Acepto
        </button> -->
      </div>
    </div>
    
    <!-- modal -->
    <div
      class="modal fade"
      id="avisoPrivacidadModal"
      tabindex="-1"
      aria-labelledby="avisoPrivacidadModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body text-center">
            <img
              src="./../../assets/img/Logotipo LS.png"
              alt="Logo Latino Seguros"
              class="img-fluid"
              style="height: 250px;"
            />
            <div class="text-center mb-4 mt-5">
              <pre class="textModal">{{ text }}</pre>
            </div>
            <button
              type="button"
              class=" col-3 btn btn-sm btn-primary btn-rounded"
              data-bs-dismiss="modal"
            >
              Aceptar
            </button>
          </div>
        </div>
      </div>
    </div>

    <loading></loading>
  </div>
</template>

<script>
import loading from '../../componentes/ImgLoading/loading.vue';
import { ref } from 'vue'
export default {
  components: { loading },
data(){
    return {
      params: this.$route.params.id,
      id: "",
      renovacion: "",
      text: "",
      ifIcono: "",
      modal: false,
      ifScroll: true
    }
}, 

methods: {
  handleScroll(el) {
    const element = document.getElementById('element');
    let lastScrollTop = 0;
    element.onscroll = (e)=>{
    if (element.scrollTop < lastScrollTop){
          return;
      } 
      lastScrollTop = element.scrollTop <= 0 ? 0 : element.scrollTop;
        if (element.scrollTop + element.offsetHeight>= element.scrollHeight ){
          this.ifScroll = false;
          console.log("End");
        }
    }
  },
  reload(){
    this.modal = false;
    window.location.reload();
  },
  //Cuando renovaccion es 0
  async aceptarRenovaO(){
    const payload = {
        metodo: "GUARDARACEPTACIONTERMINO",
        data: {
          COTIZACION: this.id,
          ACEPTO: true,
          LOCALIZACION: "",
          TELEFONO: ""
        },
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          console.log(res);
          // this.modal = true;
          this.text = "Gracias por aceptar las condiciones generales, ya puedes continuar con la contratación de tu póliza."
        }
      } catch (error) {
        console.log(error);
      }
      
  },
  //Cuando renovaccion es 1
  async aceptarRenovaU(){
    const payload = {
        metodo: "GUARDAREMISIONRENOVACION",
        data: {
          COTIZACION: this.id,
          ACEPTO: true,
          LOCALIZACION: "",
          TELEFONO: ""
        },
      };
      try {
        const response = await this.$store.dispatch("metodoPost", payload);
          
        if (response) {
          const res = this.$store.getters.getRespuestaREST;
          let error = this.$store.getters.getDataRaw.errorMessage.split("|")
          console.log(error);
          if(res != ""){
            this.modal = true;
            this.ifIcono = false;
            this.text = "Gracias por aceptar tu póliza y las condiciones generales, \nte enviaremos la póliza a tu correo. \nTu poliza es: "
             + res.POLIZA
          } else if(res == ""){
            // this.modal = true;
            // this.ifIcono = true;
            this.text = error[1]
          }
        }
      } catch (error) {
        console.log(error);
      } 
  },
  sendTerminos(){
    if(this.renovacion == 0){
      this.aceptarRenovaO();
      console.log("Entra 0");
      return;
    }
    
    if(this.renovacion == 1){
      this.aceptarRenovaU();
      console.log("Entra 1");
      return;
    }
  }
},
mounted() {
    //Separa los parametros por la &
    var splt = this.params.split("&");

    //Regresa el valor del id (solo numero)
    this.id = splt[0].replace(/[^0-9]+/g, "");
    console.log(this.id);

    //Regresa el valor de renovacion (solo numero)
    this.renovacion = splt[1].replace(/[^0-9]+/g, "");
    console.log(this.renovacion);
}
}
</script>

<style>
.textModal {
  font-family: Century Gothic,CenturyGothic,AppleGothic,sans-serif; 
  font-size: 15px; 
  color: #01427a;
}
.btn-rounded{
  border-radius: 10px;
  background-color: #01427a;
  color: white;
}
.item{
height:100px;
}
.elemento{
  margin-top: 10px;
  overflow:scroll;
  height:500px;
  width: 100%;
  align-content: center;
}
body{
  height: 100%;
  background: #ffffff;
}
p{
  font-size: small;
  width: 100%;
  margin: 0px ,10px, 10px,0;
}
iframe{
  width: 100%;
  height: 100%;
}
button{
  margin-right: 10px;
}
</style>